import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button, List, ListItem, ListItemText, Paper } from '@mui/material';
import axios from 'axios';

const Training = () => {
  const [trainings, setTrainings] = useState([]);
  const [newTraining, setNewTraining] = useState({ name: '', date: '' });

  useEffect(() => {
    fetchTrainings();
  }, []);

  const fetchTrainings = async () => {
    try {
      const res = await axios.get('/api/trainings');
      setTrainings(res.data);
    } catch {
      setTrainings([]);
    }
  };

  const handleChange = (e) => setNewTraining({ ...newTraining, [e.target.name]: e.target.value });
  const handleAdd = async () => {
    if (!newTraining.name || !newTraining.date) return;
    try {
      await axios.post('/api/trainings', newTraining);
      fetchTrainings();
      setNewTraining({ name: '', date: '' });
    } catch {}
  };

  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 4 }}>
      <Typography variant="h4" gutterBottom>Eğitimler</Typography>
      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6">Yeni Eğitim</Typography>
        <TextField label="Eğitim Adı" name="name" value={newTraining.name} onChange={handleChange} fullWidth sx={{ mb: 1 }} />
        <TextField label="Tarih" name="date" type="date" value={newTraining.date} onChange={handleChange} fullWidth sx={{ mb: 1 }} InputLabelProps={{ shrink: true }} />
        <Button variant="contained" onClick={handleAdd}>Ekle</Button>
      </Paper>
      <Typography variant="h6">Tamamlanan Eğitimler</Typography>
      <List>
        {trainings.map((t) => (
          <ListItem key={t.id}>
            <ListItemText primary={t.name} secondary={t.date} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default Training;
